// Vendor
import * as React from 'react';

// Vendor Components
import Button from 'material-ui/Button';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from 'material-ui/Dialog';
import Slide from 'material-ui/transitions/Slide';
import {translate, TranslationFunction} from 'react-i18next';
import {compose} from 'recompose';

// Types
interface Props {
  isOpen: boolean;
  message: string;
  onConfirm: (ok: boolean) => void;
}

interface TranslatedProps {
  t: TranslationFunction;
}

type EnhancedProps = Props & TranslatedProps;

const enhance = compose<EnhancedProps, Props>(translate());

const SlideUp: React.SFC<any> = props => {
  return <Slide direction="up" {...props} />;
};

export const ConfirmationPrompt: React.SFC<EnhancedProps> = ({
  t,
  isOpen,
  message,
  onConfirm
}) => (
  <Dialog open={isOpen} onClose={() => onConfirm(false)} transition={SlideUp}>
    <DialogTitle>{t('confirmation_prompt.title')}</DialogTitle>

    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button
        id="confirmation-prompt__cancel"
        onClick={() => onConfirm(false)}
        color="primary"
      >
        {t('confirmation_prompt.actions.cancel.caption')}
      </Button>

      <Button
        id="confirmation-prompt__confirm"
        onClick={() => onConfirm(true)}
        color="primary"
      >
        {t('confirmation_prompt.actions.confirm.caption')}
      </Button>
    </DialogActions>
  </Dialog>
);

export default enhance(ConfirmationPrompt);



// WEBPACK FOOTER //
// ./src/ui/components/confirmation-prompt/confirmation-prompt.tsx